import { RegexUtil } from './regex-util';
import { anyPass, isEmpty, isNil } from 'ramda';

export class StringUtil {

  static format = (str: string, ...args: string[]) =>
    str.replace(/{(\d+)}/g, (match, index) => args[index] || '');

  static removeSpecialChars = (str: string) => str.replace(RegexUtil.NOT_SPECIAL_CHARS, '');

  static isNullOrEmpty = (str: string) => anyPass([isNil, isEmpty]);

  static isNullEmpty = (str: string) => (!str || str.length === 0);

  static isNullOrWhiteSpace = (str: string | null | undefined) =>
    StringUtil.isNullOrEmpty(str)(str) || str.trim().length === 0;

  static repeated_digits_regex = /^(\d)\1+$/;

  public static obfuscateMail(mail) {
    const partsOfMail = mail.split('@');

    if (partsOfMail.length === 2) {
      const init = partsOfMail[0];
      const end = partsOfMail[1];
      const lastChar = init.substr(init.length - 1, 1);

      if (init.length > 5) {
        return `${init.substr(0, 3)}${'*'.repeat(init.length - 4)}${lastChar}@${end}`;
      }

      switch (init.length) {
        case 5:
          return `${init.substr(0, 2)}**${lastChar}@${end}`;
        case 4:
          return `${init.substr(0, 1)}**${lastChar}@${end}`;
        case 3:
          return `${init.substr(0, 1)}*${lastChar}@${end}`;
        case 2:
          return `${init.substr(0, 1)}*@${end}`;
      }
    }

    return mail;
  }

  public static obfuscateTelephone(phone){
    if (!phone) return "-";
    if (!phone.includes('*')) {
      return `${phone.substring(0, 3)}******${phone.substring(phone.length - 2, phone.length)}`;
    }
    return phone;
  }

  public static validatedName(fullNameControl) {
    const validatedName = fullNameControl?.value?.trim();
    if (!validatedName) {
      fullNameControl.setValue('');
      fullNameControl.setErrors({ required: true });
      fullNameControl.markAsTouched();
      return;
    }
    fullNameControl.setValue(fullNameControl.value.trim());
  }

  public static removeCountryCode(phoneWithCode: string, dialCode: string): string {
    const onlyDigits = phoneWithCode.replace(/\D/g, '');
    const dialCodeDigits = dialCode.replace(/\D/g, '');
    return onlyDigits.startsWith(dialCodeDigits)
      ? onlyDigits.slice(dialCodeDigits.length)
      : onlyDigits;
  }

  public static isFakePhoneNumber(phone: string): boolean {
    return StringUtil.repeated_digits_regex.test(phone);
  }
}

